import React from "react"
import * as Chakra from "@chakra-ui/react"
import FadeTransition from "../transitions/fade-transition"

interface ProjectDetailHeaderProps {
  clientName: string
  location: string
  heading: string
  bodyText: string
  extraText: string
    wpTags: { name: string }[]
}

const ProjectDetailHeader = React.forwardRef(
  (
    {
      clientName,
      location,
      heading,
      bodyText,
      wpTags,
      extraText,
    }: ProjectDetailHeaderProps,
    ref
  ) => {
    return (
      <Chakra.Box
        ref={ref}
        width="100%"
        display="flex"
        position="relative"
        alignItems="flex-start"
        flexDirection="column"
        backgroundColor="transparent"
      >
        <Chakra.Box
          display="flex"
          width="100%"
          alignItems="flex-start"
          marginLeft="auto"
          marginRight="auto"
          flexDirection="column"
          paddingBottom="37px"
          css={{
            "@media (max-width: 1200px)": {
              paddingTop: "14px",
              paddingLeft: "0px",
              paddingRight: "0px",
              paddingBottom: "46px",
            },
          }}
        >
          <Chakra.Box
            position="absolute"
            transform="translateY(-100%)"
            width="100%"
            backgroundColor="var(--background-col)"
          >
            <Chakra.Box
              maxWidth="1800px"
              display="flex"
              paddingTop="37px"
              width="100%"
              alignItems="flex-start"
              paddingLeft="40px"
              paddingRight="40px"
              flexDirection="row"
              paddingBottom="26px"
              justifyContent="space-between"
              borderTopWidth="0px"
              borderLeftWidth="0px"
              borderRightWidth="0px"
              m="auto"
              css={{
                "@media (max-width: 1200px)": {
                  flexDirection: "column",
                  paddingBottom: "14px",
                  paddingTop: "14px",
                },
                  "@media (max-width: 767px)": {
                      paddingLeft: "20px",
                      paddingRight: "20px",
                  }
              }}
            >
              <Chakra.Box
                display="flex"
                width="26%"
                position="absolute"
                alignItems="flex-start"
                flexDirection="column"
                css={{
                  "@media (max-width: 1200px)": {
                    width: "100%",
                    //paddingRight: "166px",
                      position: "relative"
                  },
                }}
              >
                <Chakra.Box
                  as="span"
                  fontSize="18px"
                  fontFamily="Beausite 400"
                  lineHeight="26px"
                  css={{
                    "@media (max-width: 1200px)": {
                      fontFamily: "BeausiteClassic-Clear",
                    },
                  }}
                >
                  {clientName}
                </Chakra.Box>
              </Chakra.Box>
              <Chakra.Box
                display="flex"
                width="70%"
                maxWidth="668px"
                margin="auto"
                alignItems="flex-start"
                flexDirection="column"
                css={{
                  "@media (max-width: 1200px)": {
                      width: "100%",
                      maxWidth: "100%"
                  },
                }}
              >
                <Chakra.Box
                  as="span"
                  fontSize="18px"
                  fontFamily="Beausite 400"
                  lineHeight="26px"
                  css={{
                    "@media (max-width: 1200px)": {
                      fontFamily: "BeausiteClassic-Clear",
                    },
                  }}
                >
                  {location}
                </Chakra.Box>
              </Chakra.Box>
            </Chakra.Box>
            <Chakra.Box
              height="1px"
              backgroundColor="currentColor"
              width="100%"
            />
          </Chakra.Box>
          <Chakra.Box
            m="auto"
            display="flex"
            width="100%"
            maxWidth="1800px"
            alignItems="flex-start"
            paddingTop="30px"
            paddingLeft="40px"
            paddingRight="40px"
            flexDirection="row"
            paddingBottom="26px"
            justifyContent="space-between"
            css={{
              "@media (max-width: 1200px)": {
                flexDirection: "column",
                  paddingLeft: 0,
                  paddingRight: 0
              },
            }}
          >
            <Chakra.Box
              display="flex"
              width="26%"
              position="absolute"
              alignItems="flex-start"
              flexDirection="column"
              css={{
                "@media (max-width: 1200px)": {
                    position: "relative",
                    paddingLeft: "40px",
                    paddingRight: "40px",
                  width: "100%",
                  borderColor: "currentColor",
                  borderWidth: "1px",
                  borderTopWidth: "0px",
                  borderLeftWidth: "0px",
                  borderRightWidth: "0px",
                },
                  "@media (max-width: 767px)": {
                      paddingLeft: "20px",
                      paddingRight: "20px"
                  }
              }}
            >
              <Chakra.Box
                as="span"
                color="currentColor"
                opacity="0.5"
                fontSize="16px"
                maxWidth="120px"
                fontFamily="Beausite 400"
                lineHeight="24px"
                css={{
                  "@media (max-width: 1200px)": {
                    fontSize: "14px",
                    fontFamily: "BeausiteClassic-Clear",
                    lineHeight: "16.8px",
                    paddingBottom: "28px",
                  },
                }}
              >
                {wpTags && wpTags.map(({ name }) => <div>{name}</div>)}
              </Chakra.Box>
            </Chakra.Box>
            <Chakra.Box
              display="flex"
              width="70%"
              alignItems="flex-start"
              //paddingRight="332px"
                maxWidth="668px"
              m="auto"
              flexDirection="column"
              css={{
                "@media (max-width: 1200px)": {
                  width: "100%",
                    maxWidth: "100%",
                    paddingTop: "40px",
                    paddingLeft: "40px",
                    paddingRight: "40px"
                },
                  "@media (max-width: 767px)": {
                      paddingTop: "20px",
                      paddingLeft: "20px",
                  },
                "@media (max-width: 479px)": {
                  paddingRight: "20px",
                },
              }}
            >
              <Chakra.Box
                as="span"
                fontFamily="Beausite 400"
                lineHeight="43px"
                letterSpacing="-1%"
                fontSize="36px"
                paddingBottom="52px"
                css={{
                  "@media (max-width: 1200px)": {
                    fontSize: "26px",
                    fontFamily: "BeausiteClassic-Clear",
                    lineHeight: "31px",
                    paddingBottom: "32px",
                  },
                }}
              >
                {heading}
              </Chakra.Box>
              <Chakra.Box
                as="span"
                fontSize="18px"
                fontFamily="BeausiteClassic-Clear"
                lineHeight="26px"
                letterSpacing="-1%"
                paddingBottom="30px"
              >
                {bodyText}
              </Chakra.Box>
              <Chakra.Accordion width="100%" allowToggle>
                <Chakra.AccordionItem width="100%" border="none">
                  {({ isExpanded }) => (
                    <>
                      <Chakra.AccordionPanel
                        fontSize="18px"
                        fontFamily="BeausiteClassic-Clear"
                        lineHeight="26px"
                        paddingTop="0px"
                        paddingLeft="0px"
                        paddingRight="0px"
                        paddingBottom="30px"
                      >
                        {extraText}
                      </Chakra.AccordionPanel>
                      <Chakra.AccordionButton
                        fontSize="18px"
                        fontFamily="BeausiteClassic-Clear"
                        lineHeight="26px"
                        paddingTop="0px"
                        borderWidth="1px"
                        paddingLeft="0px"
                        paddingRight="0px"
                        paddingBottom="0px"
                        opacity="0.5"
                        display="inline-block"
                        borderColor="transparent"
                        borderRadius="4px"
                        textAlign="left"
                        position="relative"
                        width="fit-content"
                        _hover={{
                          backgroundColor: "transparent",
                          opacity: 1,
                          "&:after": {
                            opacity: "1",
                          },
                        }}
                        _active={{
                          backgroundColor: "transparent",
                          opacity: 0.5,
                        }}
                        _focus={{
                          backgroundColor: "transparent",
                          opacity: 0.5,
                        }}
                        _after={{
                          transition: "0.1s",
                          content: "''",
                          position: "absolute",
                          left: "0",
                          width: "100%",
                          opacity: "0",
                          height: "1px",
                          bottom: "0",
                          backgroundColor: "currentColor",
                        }}
                      >
                        <FadeTransition shouldChange={isExpanded.toString()}>
                          {isExpanded ? "Read Less" : "Read More"}
                        </FadeTransition>
                      </Chakra.AccordionButton>
                    </>
                  )}
                </Chakra.AccordionItem>
              </Chakra.Accordion>
            </Chakra.Box>
          </Chakra.Box>
        </Chakra.Box>
      </Chakra.Box>
    )
  }
)

ProjectDetailHeader.pressless = {
  name: "Project Detail Header",
  attributes: {
    clientName: {
      name: "Client Name",
      type: "RichText",
    },
    location: {
      name: "Location",
      type: "RichText",
    },
    heading: {
      name: "Heading",
      type: "RichText",
    },
    bodyText: {
      name: "Body Text",
      type: "RichText",
    },
    extraText: {
      name: "Extra Text",
      type: "RichText",
    },
  },
}
export default ProjectDetailHeader
